<template>
	<div class="container" id="topTarget" @scroll="goscroll">
		<div class="title">
			<!-- <span @click="go" style="margin-left: 20px;">返回</span> -->
			<!-- <el-divider direction="vertical"></el-divider> -->

		</div>
		<div style="display: flex;align-items: center;justify-content: center;height: 10px;">
			{{title}}移库单
		</div>
		<div style="padding: 50px;">
			<el-form v-model="storelinks">
				<div style="display: flex;">
					 <el-form-item label="仓库" label-width="120px">
						<el-select filterable v-model="storelinks.warehouseId" style="width: 220px" placeholder="请选择" clear 
						@change="warehouseChange">
                        <!-- :remote-method="WarehouseLis" remote allow-create learable -->
							<el-option v-for="it in entrepotList" :key="it.id" :value="it.id" :label="it.warehouseName"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="客户:" label-width="120px" >
						<el-select filterable v-model="storelinks.customerId" placeholder="请选择" clear value-key="id"
						  style="width: 220px">
							<el-option v-for="it in userList" :key="it.customerId" :value="it.customerId"
								:label="it.customerName"></el-option>
						</el-select>
						<!-- @change="customerSelect" -->
					</el-form-item>
					<el-form-item label="移库单号:" label-width="120px">
						<el-input type="text" placeholder="请输入移库单号"  v-model="storelinks.orderCode" style="width: 220px;" 
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="移库日期:" label-width="120px" >
						<el-date-picker value-format="yyyy-MM-dd" v-model="storelinks.storageTime" placeholder="选择移库日期:" style="width: 220px;" >
						</el-date-picker>
					</el-form-item>
				</div>
				<div style="display: flex;">
					<el-form-item label="操作人:" label-width="120px">
						<el-input type="text" placeholder="请输入操作人"  v-model="storelinks.receiver" style="width: 220px; "
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="确认人:" label-width="120px">
						<el-input type="text"  placeholder="请输入确认人"  v-model="storelinks.stevedore" style="width: 220px; "
							auto-complete="off" />
					</el-form-item>
					<el-form-item label="作业开始时间:" label-width="120px">
						<el-date-picker
                            v-model="storelinks.beginDatetime" style="width: 220px; "
                            type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="选择日期时间"> 
                        </el-date-picker>
					</el-form-item>
					<el-form-item label="作业结束时间:" label-width="120px">
						<el-date-picker
							v-model="storelinks.endDatetime" style="width: 220px; "
							type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
							placeholder="选择日期时间">
						</el-date-picker>
					</el-form-item>
				</div>
				<div style="display: flex;">
					<el-form-item label="制单人:" label-width="120px">
						<el-input type="text" style="width: 220px; " placeholder="请输入制单人"  v-model="storelinks.createBy" disabled
							auto-complete="off" />
					</el-form-item>
					
					<el-form-item label="备注:" label-width="120px">
						<el-input type="textarea" :rows="2" style="width: 900px; " placeholder="请输入备注"  v-model="storelinks.memo"
							auto-complete="off" />
					</el-form-item> 
					
				</div>
			
				<div style="width:100%;position: relative;">
					<div style="justify-content: space-between;display: flex;align-items: center;margin-bottom:-10px;">
						<div style="color: #606266;width:40%">移库商品</div>
						<!-- <div v-if="storelinks.printTimes!=0" style="padding-right:20px;width:60%;text-align: right;">
							<span>打印次数:</span>
							<span style="padding-left:5px;">{{storelinks.printTimes}}</span>
							<span>次</span>
							<span style="padding-left:20px;">打印时间:</span>	
							<span style="padding-left:5px;">{{storelinks.lastPrintDatetime}}</span>
						</div> -->
						<div>
							<el-form-item label="状态:" label-width="120px">
								<span v-if="storelinks.status==0" style="color:#409EFF;font-weight: bold;">制单中</span>
								<span v-if="storelinks.status==1" style="color:#F7BA2A;font-weight: bold;">移库中</span>
								<span v-if="storelinks.status==2" style="color:#13CE66;font-weight: bold;">已完成</span>
							</el-form-item>
						</div>
					</div>
					<el-form-item  prop="remark">
						<div style="width: 100%;">
							<!-- 添加按钮 -->
							<el-table :data="dataList" size="mini" style="width: 100%;" border @row-click="handleRowClick"
							current-row-key="index" @current-change="handleCurrentChange">
								<el-table-column type="index" label="序号" width="50"></el-table-column>
								<!-- <el-table-column prop="customerOrderCode" label="客户单号" :show-overflow-tooltip="true" min-width="100">
									<template slot-scope="scope">
										<el-input  :id="'sel'+scope.$index"  @blur="aa(scope.$index,scope.row,'customerOrderCode')" v-model.trim="scope.row.customerOrderCode" placeholder="请输入客户单号" clearable>
										</el-input>
									</template>
								</el-table-column> -->
								<el-table-column prop="pdtCode" label="商品编号" width="190" align="center">
									<template slot-scope="scope">
										<el-select  :remote-method="goodsInput"  
											filterable  v-model="scope.row.pdtCode" 
											remote @focus="selectFocus(scope.$index, $event, scope.row)"
											@keyup.enter.native="goodCodeChange(scope.$index,$event,scope.row)"
											@change="goodChange(scope.$index,$event,scope.row)"
											allow-create
											clearable
											placeholder="请选择" >
											<div style="display: flex;padding: 0 20px;font-size: 14px;">
												<span style="width:150px;display: inline-block;">商品编号</span>
												<span style="width:80px;display: inline-block;">源库位</span>
												<span style="width:80px;display: inline-block;">商品状态</span>
												<span style="width:120px;display: inline-block;">批次</span>
												<span style="width:80px;display: inline-block;">库存</span>
												<span style="width:80px;display: inline-block;">库存EA</span>
												<span style="padding-left:30px;display: inline-block;">商品名称</span>
											</div>
											<el-option v-for="(item,index) in goodsDataList" :key="index" :label="item.pdtCode" :value="item.id">
												<!-- @click.native="select(scope.$index,item,index)"  -->
												<!-- <span style="float: left">{{ item.goodsName }}</span>
												<span style="float: right; color: #8492a6; font-size: 13px">{{ item.pdtCode }}</span> -->
												<span style="width:150px; color: #8492a6;display: inline-block;">{{ item.pdtCode }}</span>
												<span style="width:80px; color: #20A0FF; display: inline-block;">{{ item.warehouseLocationName }}</span>
												<span style="width:80px; color: #20A0FF; display: inline-block;">{{ item.goodsStatusName }}</span>
												<span style="width:120px; color: #20A0FF; display: inline-block;">{{ item.batchNo }}</span>
												<span style="width:80px; color: #20A0FF; display: inline-block;">{{ item.num }}</span>
												<span style="width:80px; color: #20A0FF; display: inline-block;">{{ item.eaNum }}</span>
												<span style="padding-left:30px;display: inline-block;">{{ item.pdtName }}</span>
											</el-option>
										</el-select>
									</template>
								</el-table-column>
								
								<el-table-column prop="pdtName" width="150" label="商品名称" align="center"
									class-name="small-padding ">
								</el-table-column>
								<el-table-column prop="warehouseLocationFromName" width="100" label="源库位" align="center">
								</el-table-column>
								<el-table-column prop="goodsStatusName" width="80" label="商品状态" align="center">
								</el-table-column>
								<el-table-column prop="batchNo" width="100" label="批次" align="center">
								</el-table-column>
								<el-table-column prop="numOne" width="100" label="库存数" align="center">
								</el-table-column>
								<el-table-column prop="eaNumOne" width="100" label="库存数EA" align="center">
								</el-table-column>
								<el-table-column prop="num" width="100" label="移动数"  align="center">
									<template slot-scope="scope">
										<el-input @input="inputInputRight(scope.$index, scope.row ,'num')"
										v-model.trim="scope.row.num" placeholder="移动数" clearable>
										</el-input>
									</template>
								</el-table-column>
								
								<el-table-column prop="eaNum" width="100" label="移动数EA"  align="center">
									<template slot-scope="scope">
										<el-input @input="inputInputRight(scope.$index, scope.row ,'eaNum')"
										v-model.trim="scope.row.eaNum" placeholder="移动数EA" clearable>
										</el-input>
									</template>
								</el-table-column>
								<el-table-column prop="warehouseLocationTo" label="目标库位" align="center" width="120">
									<template slot-scope="scope">
										<!-- remote  :remote-method="districtFocus"   -->
										<el-select filterable clearable v-model="scope.row.warehouseLocationTo" 
											@focus="selectFocus(scope.$index, $event, scope.row)"
											placeholder="请选择"  @change="warehouseLocationChange">
											<!-- @blur="inputBlurRight(scope.$index,scope.row,'warehouseLocationId')" -->
										<el-option v-for="it in locationList" :key="it.id" :value="it.id" 
										:label="it.warehouseLocationName" ></el-option>
										</el-select>
									</template>
								</el-table-column>
								<el-table-column prop="remark" width="" label="备注"  align="center">
										<template slot-scope="scope">
											<el-input v-model.trim="scope.row.remark" placeholder="请输入备注" clearable
											@input="remarkInput"></el-input>
										</template>
									</el-table-column>
								<el-table-column  width="120" label="操作" fixed="right" align="center"
									v-if="storelinks.status!=2"
									class-name="small-padding fixed-width">
									<template slot-scope="scope">
										<el-button type="text" icon="el-icon-delete"
											@click="handleDelete(scope.$index, scope.row)"></el-button>

											<el-button type="text" icon="el-icon-plus" 
												v-if="scope.$index==dataList.length-1" @click="addCarousel(scope.$index)"></el-button>
											
											<el-button v-if="tableClickID==scope.row.id"  type="text" 
												@click="tableBC(scope.$index, scope.row)">保存</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
					</el-form-item>
				</div>
				
				<el-button type="primary" v-if="storelinks.status==0" style="float: left;margin-right: 100px;" @click="toBlockUp">入库中</el-button>
				<el-button type="primary" v-if="storelinks.status==1" style="float: left;margin-right: 100px;" @click="toStartUsing">关单</el-button>

				<el-button type="primary" v-if="storelinks.status!=2" style="float: right;margin-right: 80px;" @click="submitClick">提交</el-button>
			</el-form>
		</div>
	</div>
</template>

<script>
	import moment from 'moment'; 
	var qwer = moment().format('YYYYMMDD');
	import goodsMagnifierZoom from '../../components/goods-zoom.vue';
	  import _ from 'lodash';

	export default {
		props:['order'],
		name: "GoodsZoom",
		components: {
			goodsMagnifierZoom: goodsMagnifierZoom,
		},
		data() {
			return {
				isReturn:true,
				detaillist: {},
				title:'',
				unitList: [],
				arsList:[],
				queryParam: '',
				isJoinCar:3,
				driverList:[],
				num: 1,
				typeList: [],
				flag:false,
				userList: [],
				storelinks: {
					orderCode: '',
					createBy: ''
				},
				orderInfo: {},
				goodsList: [],
				form: {},
				dataList: [
					{
						pdtCode: '',
						num: '',
						eaNum: '',
						warehouseLocationTo: ''
					}
				],
				formData: {},
				
				goodsDataList: [],
				contractList: [],
				typeList: [],
				ids:'',
				tableClickID:0, //表格点击的ID
				carNumberplate:'',
				routeList: [],
				isDataChangeCount:0,

				locationList: [],
				entrepotList: [],

				tableChange: 0,
			}
		},
		watch: {
			carNumberplate(newValue, oldValue) {
			
				this.isJoinCar=this.arsList.find(item=>item.carNumberplate==newValue).isJoinCar
			},
			
			
			storelinks:{
				handler(a,b){
				
					if(this.$route.query.id){
						this.isDataChangeCount++
					
					}else{
						this.isDataChangeCount++
						
						
					}
					
				},
				deep:true
			},
			'storelinks.routeId'(a,b){
			
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
					
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
					
					}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
					
					}
					this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
				}else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceTrips
						
						}else if(this.storelinks.billingType==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceVolume*this.storelinks.number
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==a).priceWeight*this.storelinks.number
						
						}
						this.storelinks.driveSendReward=this.routeList.find(item=>item.id==a).driveSendReward
					}
				}
			
					
				
			},
			
			'storelinks.billingType'(a,b){
				if(!this.$route.query.id){
					if(a==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						
					}else if(a==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
					}else if(a==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
					
					}
				}else{
					if(this.isDataChangeCount>1){
						if(a==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
				
						}else if(a==2){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*this.storelinks.number
						}else if(a==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*this.storelinks.number
						
						}
					}
				}
				
				
			},
			'storelinks.number'(a,b){
				if(!this.$route.query.id){
					if(this.storelinks.billingType==1){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
					}else if(this.storelinks.billingType==2){
					this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
					}else if(this.storelinks.billingType==3){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
					
					}
				}
				else{
					if(this.isDataChangeCount>1){
						if(this.storelinks.billingType==1){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceTrips
						}else if(this.storelinks.billingType==2){
						this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceVolume*a
						}else if(this.storelinks.billingType==3){
							this.storelinks.freightPrice=this.routeList.find(item=>item.id==this.storelinks.routeId).priceWeight*a
						
						}
					}
				}
			},
			
		},
		
		methods: {
			toBlockUp() {
				if(this.$route.query.id){
					if(this.isDataChangeCount>1){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}else{
					if(this.isDataChangeCount>0){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}
				// console.log(e)
				var str = "此操作将移库中, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.wmsTransOrdertUpdateStatus(this.orderInfo.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							// this.findPmsUnit();
							this.init()
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			toStartUsing() {
				if(this.$route.query.id){
					if(this.isDataChangeCount>1){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}else{
					if(this.isDataChangeCount>0){
						this.$message.error('还有待提交数据，请先提交')
						return
					}
				}
				// console.log(e)
				var str = "此操作将关单, 是否继续?"
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// console.log(e)
					this.$api.wmsTransOrdertUpdateStatus(this.orderInfo.id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							// this.findPmsUnit();
							this.init()
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			inputInputRight(index,b,c){
				// console.log('箱规2--', b)
				this.tableChange = 1;
				if(c=='num'){
					if(b.num==0){
						this.$message.error('移动数不可以为0');
						return
					}
					if(b.num > b.numOne){
						this.$message.error('移动数不可以大于库存数');
						return
					}
					if(b.boxGauge){
						b.eaNum = Number(b.num) * Number(b.boxGauge)
						// console.log('b.eaNum--', b.eaNum)
					}else{
						b.eaNum = b.eaNum
					}
					
				}
				// if(c=='eaNum' && b.eaNum==0){
				// 	this.$message.error('移动数EA不可以为0');
				// 	return
				// }
				// if(c == 'num'){
				// 	// b.qtyReceived = b.num
				// 	if(b.boxGauge){
				// 		b.eaNum = Number(b.num) * Number(b.boxGauge)
				// 		// console.log('b.eaNum--', b.eaNum)
				// 	}else{
				// 		b.eaNum = b.eaNum
				// 	}
				// 	return
				// }
			},
			remarkInput(){
				this.tableChange = 1;
			},
			carchange(it){
				
			},
			Date(){
				 const now = new Date();
					const year = now.getFullYear(); // 获取当前年份
					const month = now.getMonth() + 1; // 月份从 0 开始，所以要加1
					const day = now.getDate(); // 获取当前日期
				return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
			},
			wanc(){
				
				this.$api.completeByID(this.orderInfo.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.init();
					} else {
						this.$message.error(res.message);
					}
				})
			},
			changesj(e){
				
				this.carNumberplate=e.carNumberplate
			},
			handleRowClick(row, event, column) {
				// row 对象即为点击的行数据
				this.$nextTick(()=>{
					this.tableClickID = row.id
				})
			},
			handleCurrentChange(currentRow, oldCurrentRow) { //当前行发生变化
				// row 对象即为点击的行数据
				// this.$nextTick(()=>{
				// 	this.tableClickID = row.id
				// })
				// console.log('变化了--', currentRow)
				// console.log('变化了老的行--', oldCurrentRow)
			},
			selectFocus(index,e,row){ //下拉框获取焦点
				// console.log('下拉框获取焦点--', index)
				this.$nextTick(()=>{
					this.tableClickID = row.id
				})
			},
			goodChange(a,e,b){
				// console.log('22333')
				this.tableChange = 1;
				this.ids = e;
				let obj = {};
				obj = this.goodsDataList.find((item) => { //这里上面遍历的数据源
					return item.id == e; //筛选出匹配数据
				});
				// console.log('商品匹配--', obj)
				b.pdtId = obj.pdtId;
				b.pdtCode = obj.pdtCode;
				b.pdtName = obj.pdtName;
				b.unitName = obj.unitName;
				b.boxGauge = obj.boxGauge;
				b.numOne = obj.num;
				b.eaNumOne = obj.eaNum;
				b.warehouseLocationFrom = obj.warehouseLocationId;
				b.warehouseLocationFromName = obj.warehouseLocationName;
				b.warehouseLocationName = obj.warehouseLocationName;
				b.batchNo = obj.batchNo;
				b.goodsStatusName = obj.goodsStatusName;
				b.goodsStatus = obj.goodsStatus;
				// console.log('商品选择了--', b)

				let data={
					orderId:this.orderInfo.id,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					pdtName:b.pdtName,
					warehouseLocationFrom: b.warehouseLocationFrom,
					warehouseLocationFromName: b.warehouseLocationName,
					warehouseLocationTo: b.warehouseLocationTo,
					goodsStatus: b.goodsStatus,
					batchNo: b.batchNo,
					numOne: b.numOne,
					eaNumOne: b.eaNumOne,
					boxGauge: b.boxGauge,
					num:b.num,
					eaNum:b.eaNum,
					unitName:b.unitName,
					remark:b.remark,
				}
				let _this = this;
				// console.log('行参数---', data)
				if(b.id){
					this.$api.updateWmsTransOrderGoodsList({...data,id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('编辑--', res.data)		
						if(res.state=='success'){
							this.dataList[a]=res.data
							this.$api.getWmsTransOrderInfoByID(this.orderInfo.id).then(ress=>{
								// res.data=JSON.parse(this.$decrypt(res.data)).data
								if(ress.state=='success'){
									this.dataList = ress.data.children;
								}else{
									this.$message.error(ress.message)
								}
							})
						}else{
							_this.dataList.splice(a, 1)
							this.$message.error(res.message)
						}
					})
				}else{
					this.$api.addWmsTransOrderGoodsList(data).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('新增--', res.data)
						if(res.state=='success'){
							this.$api.getWmsTransOrderInfoByID(this.orderInfo.id).then(ress=>{
								// res.data=JSON.parse(this.$decrypt(res.data)).data
								if(ress.state=='success'){
									this.dataList = ress.data.children;
								}else{
									this.$message.error(ress.message)
								}
							})
						}else{
							_this.dataList.splice(a, 1)
							this.$message.error(res.message)
						}
					})
				}
			},
			goodCodeChange(a,e,b){
				this.tableChange = 1;
				let obj = {};
				obj = this.goodsDataList.find((item) => { //这里就是上面遍历的数据源
					return item.id == e; //筛选出匹配数据
				});
				// console.log('选择商品--', obj)
				// this.$set(this.dataList[a],'pdtName',obj.pdtName)
				// this.$set(this.dataList[a],'pdtId',obj.pdtId)
				// this.$set(this.dataList[a],'numOne',obj.num)
				// this.$set(this.dataList[a],'eaNumOne',obj.eaNum)
				// this.$set(this.dataList[a],'pdtCode',obj.pdtCode)
				// // this.$set(this.dataList[a],'unitName',obj.unitName)
				// this.$set(this.dataList[a],'warehouseLocationName',obj.warehouseLocationName)
				// this.$set(this.dataList[a],'batchNo',obj.batchNo)
				// this.$set(this.dataList[a],'goodsStatusName',obj.goodsStatusName)
				
				// this.$set(this.dataList[a],'id',this.dataList[a].id)
				// console.log('1223--', this.dataList[a])

				b.pdtId = obj.pdtId;
				b.pdtCode = obj.pdtCode;
				b.pdtName = obj.pdtName;
				b.unitName = obj.unitName;
				b.boxGauge = obj.boxGauge;
				b.numOne = obj.num;
				b.eaNumOne = obj.eaNum;
				b.warehouseLocationId = obj.warehouseLocationId;
				b.warehouseLocationName = obj.warehouseLocationName;
				b.batchNo = obj.batchNo;
				b.goodsStatusName = obj.goodsStatusName;
				b.goodsStatus = obj.goodsStatus;

				let data={
					orderId:this.orderInfo.id,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					pdtName:b.pdtName,
					warehouseLocationFrom: b.warehouseLocationFrom,
					warehouseLocationFromName: b.warehouseLocationName,
					warehouseLocationTo: b.warehouseLocationTo,
					goodsStatus: b.goodsStatus,
					batchNo: b.batchNo,
					numOne: b.numOne,
					eaNumOne: b.eaNumOne,
					boxGauge: b.boxGauge,
					num:b.num,
					eaNum:b.eaNum,
					unitName:b.unitName,
					remark:b.remark,
				}
				if(b.id){
					this.$api.updateWmsTransOrderGoodsList({...data,id:b.id}).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('编辑--', res.data)		
						if(res.state=='success'){
							this.$api.getWmsTransOrderInfoByID(this.orderInfo.id).then(ress=>{
								// res.data=JSON.parse(this.$decrypt(res.data)).data
								if(ress.state=='success'){
									this.dataList = ress.data.children;
								}else{
									this.$message.error(ress.message)
								}
							})
						}else{
							// b = {}
							_this.dataList.splice(a, 1)
							this.$message.error(res.message)
						}
					})
				}else{
					this.$api.addWmsTransOrderGoodsList(data).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('新增--', res.data)
						if(res.state=='success'){
							this.$api.getWmsTransOrderInfoByID(this.orderInfo.id).then(ress=>{
								// res.data=JSON.parse(this.$decrypt(res.data)).data
								if(ress.state=='success'){
									this.dataList = ress.data.children;
								}else{
									this.$message.error(ress.message)
								}
							})
						}else{
							// b = {}
							_this.dataList.splice(a, 1)
							this.$message.error(res.message)
						}
					})
				}
			},
			warehouseLocationChange(e){
				this.tableChange = 1;
			},
			keydown(index,b){
					let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					goodsName:b.goodsName,
					goodsId:b.goodsId,
					customerOrderCode:b.customerOrderCode,
					unitName:b.unitName,
					remark:b.remark,
					num:b.num,
				}
				if(b.id){
					this.$api.uporderList(this.$encrypt({...data,id:b.id})).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
					
						if(res.state=='success'){
							this.dataList=res.data
							this.handleAdd()
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
						}else{
							this.$message.error(res.message)
						}
					})
				}else{
					this.$api.addorderL(this.$encrypt(data)).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
						if(res.state=='success'){
							this.dataList=res.data
							this.handleAdd()
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
						}else{
							// console.log('0000000000');
							this.$message.error(res.message)
						}
					})
				}			
				
			
			
				
			},
			submitClick(){
				 if (this.$vnode && this.$vnode.data.keepAlive){
					if (this.$vnode.parent && this.$vnode.parent.componentInstance && this.$vnode.parent.componentInstance.cache){
						if (this.$vnode.componentOptions){
							var key = this.$vnode.key == null? this.$vnode.componentOptions.Ctor.cid + (this.$vnode.componentOptions.tag
							? `::${this.$vnode.componentOptions.tag}` : ''): this.$vnode.key;
							var cache = this.$vnode.parent.componentInstance.cache;
							var keys  = this.$vnode.parent.componentInstance.keys;
							if (cache[key]){
								if (keys.length) {
									var index = keys.indexOf(key);
									if (index > -1) {
										keys.splice(index, 1);
									}
								}
								delete cache[key];
							}
						}
					}
				}
				// console.log('保存数据---', this.storelinks)

				if(this.storelinks.warehouseId){}else{
                    this.$message.error('移库仓库不能为空');
                    return
                }
                // if(this.storelinks.orderType){}else{
                //     this.$message.error('订单类型不能为空');
                //     return
				// }
				
                if(this.storelinks.customerId){}else{
                    this.$message.error('客户不能为空');
                    return
				}
				if(this.tableClickID!=0 || this.tableChange > 0){
					this.$message.error('移库商品表格里还有未保存的数据');
                    return
				}
				let data={
                    // ...this.storelinks,
                    warehouseId: this.storelinks.warehouseId, //入库仓库
                    orderCode: this.storelinks.orderCode, //移库单号
                    customerId: this.storelinks.customerId, //客户
                    // customerName: this.storelinks.customerName, //客户名称
                    receiver: this.storelinks.receiver, //收货人
                    stevedore: this.storelinks.stevedore, //装卸组
                    memo: this.storelinks.memo, //备注
                    beginDatetime: this.storelinks.beginDatetime, //开始时间
					endDatetime:this.storelinks.endDatetime, //结束时间
					storageTime: this.storelinks.storageTime, //移库日期
					id: this.orderInfo.id,
					// createBy: this.storelinks.storageTime,
				}
				// this.$api.addWmsTransOrderInfo(data).then(res=>{
				// 	if (res.state == 'success') {
				// 		this.$message({
				// 			message: res.message,
				// 			type: 'success'
				// 		});
				// 	} else {
				// 		this.$message.error(res.message);
				// 	}
				// })

				this.$api.updateWmsTransOrderInfo(data).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						// this.$store.commit('setactiveindex','/warehouseBill/wrehouseTransferOrder')
						setTimeout(()=>{
							this.title='编辑'
							this.$router.push({
								path: '/warehouseBill/wrehouseTransferOrder'
							})
							this.$store.commit('setactiveindex', '/warehouseBill/wrehouseTransferOrder')
							// this.$router.go(-1)
						},1000)
					} else {
						this.$message.error(res.message);
					}
				})
			},
			tableBC(index,b){
				let a='sel'+(index+1)
				if(b.num == '' || b.num == 0){
					this.$message.error('请输入有效的移动数')
					return
				}
				if(b.num > b.numOne){
					this.$message.error('移动数不可大于库存数')
					return
				}
				if(b.warehouseLocationTo == '' || b.warehouseLocationTo == 0 || b.warehouseLocationTo == null){
					this.$message.error('请选择目标库位')
					return
				}

				let data={
					orderId:this.orderInfo.id,
					pdtId:b.pdtId,
					pdtCode:b.pdtCode,
					pdtName:b.pdtName,
					warehouseLocationFrom: b.warehouseLocationFrom,
					warehouseLocationFromName: b.warehouseLocationName,
					warehouseLocationTo: b.warehouseLocationTo,
					goodsStatus: b.goodsStatus,
					batchNo: b.batchNo,
					numOne: b.numOne,
					eaNumOne: b.eaNumOne,
					boxGauge: b.boxGauge,
					num:b.num,
					eaNum:b.eaNum,
					unitName:b.unitName,
					remark:b.remark,
				}
				if(b.id){
					this.$api.updateWmsTransOrderGoodsList({...data,id:b.id}).then(res=>{
					
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('编辑--', res.data)		
						if(res.state=='success'){
							
							// this.dataList[index]=res.data
							// this.$nextTick(()=>{
							// 	document.getElementById(a).focus();
							// })
							// this.handleAdd()
							this.$api.getWmsTransOrderInfoByID(this.orderInfo.id).then(ress=>{
								// res.data=JSON.parse(this.$decrypt(res.data)).data
								if(ress.state=='success'){
									this.dataList = ress.data.children;
								}else{
									this.$message.error(ress.message)
								}
							})
							this.$message.success('保存成功')
							this.tableChange = 0;
							this.tableClickID = 0;
						}else{
							this.$message.error(res.message)
						}
					})
				}else{
					this.$api.addWmsTransOrderGoodsList(data).then(res=>{
						// res=JSON.parse(this.$decrypt(res.data))
						// console.log('新增--', res.data)
						if(res.state=='success'){
							// this.dataList[index]=res.data
							// this.$nextTick(()=>{
							// 		document.getElementById(a).focus();
							// })
							// this.handleAdd()
							this.$api.getWmsTransOrderInfoByID(this.orderInfo.id).then(ress=>{
								// res.data=JSON.parse(this.$decrypt(res.data)).data
								if(ress.state=='success'){
									this.dataList = ress.data.children;
								}else{
									this.$message.error(ress.message)
								}
							})
							this.$message.success('保存成功')
							this.tableChange = 0;
							this.tableClickID = 0;
						}else{
							this.$message.error(res.message)
						}
					})
				}
				
			
			},
			
			
			select(a,item,index) {
				// console.log(this.dataList);
			   // this.dataList[a]=item
				this.$set(this.dataList[a],'goodsName',item.goodsName)
				this.$set(this.dataList[a],'goodsId',item.goodsId)
				this.$set(this.dataList[a],'index',index)
				this.$set(this.dataList[a],'pdtCode',item.pdtCode)
				this.$set(this.dataList[a],'unitName',item.unitName)
		
			},
			addCarousel(){
				if(this.tableClickID!=0){
					this.$message.error('请先保存这一行的数据');
					return
				}
				this.handleAdd();
				// let a='sel'+(index+1)
				// this.$nextTick(()=>{
				// 	document.getElementById(a).focus();
				// })
			},
			// 添加行
			handleAdd() {
				var _this = this
				let list = {
					pdtCode: '',
					num: '',	
					eaNum: '',
					warehouseLocationTo: ''
				}

				_this.dataList.push(list)
			},
			// 删除行
			handleDelete(index, row) {
				var _this = this
				this.$api.delWmsTransOrderGoodsListByID(row.id).then(res=>{
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
							// _this.dataList.splice(index, 1)
						this.$api.getWmsTransOrderInfoByID(this.$route.query.id).then(ress=>{
								// res.data=JSON.parse(this.$decrypt(res.data)).data
							if(ress.state=='success'){
								this.dataList = ress.data.children;
							}else{
								this.$message.error(ress.message)
							}
						})
					} else {
						this.$message.error(res.message);
					}
				})
			},
			goodsInput(e) {
				if(this.storelinks.warehouseId || this.storelinks.customerId){}else{
					this.$message.error('请先选择仓库和客户');
					return
				}
				this.goodsDataList=[] 
				let data = {
					queryParam: e,
					warehouseId: this.storelinks.warehouseId,
					customerId: this.storelinks.customerId
				}
				// console.log('参数---', data)
				// this.$encrypt()
				this.$api.getGoodsListByWarehouseAndClient(data).then(res => {
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('商品---', res.data)
					if (res.data.length > 0) {
						this.goodsDataList = res.data;
						this.flag=true
					} else {
						this.goodsDataList = []
					}
				})
			},
			goscroll(e) {
			
			},
			goBack() {
				topTarget.scrollIntoView();
			},
			aa(index,b,c){
				let a='sel'+(index+1)
				let data={
					orderId:this.orderInfo.id,
					goodsName:b.goodsName,
					customerOrderCode:b.customerOrderCode,
					goodsId:b.goodsId,
					unitName:b.unitName,
					remark:b.remark,
					num:b.num,
				}
							
				if(b.id){
					this.$api.uporderList(this.$encrypt({...data,id:b.id})).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦事件返回数据--',res.data);
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
							// console.log(res);
							this.$message.error(res.message)
						}
					})
				}else{
					// console.log(data);
					this.$api.addorderL(this.$encrypt(data)).then(res=>{
						res=JSON.parse(this.$decrypt(res.data))
						// console.log('失焦事件返回数据--',res.data);
						if(res.state=='success'){
							this.dataList=res.data
							this.$nextTick(()=>{
									document.getElementById(a).focus();
							})
							this.handleAdd()
						}else{
						// console.log(1111111111);
							this.$message.error(res.message)
						}
					})
				}
				
			},
			go() {  
				// console.log(this.$route);
				if(this.storelinks.status==5){
					this.$store.commit('setactiveindex','/orderManagement/addorder')
					this.$router.go(-1)
				}else{
					if(this.$route.query.id){
						if(this.isDataChangeCount>1){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$store.commit('setactiveindex','/orderManagement/addorder')
							this.$router.go(-1)
						}
					}else{
						if(this.isDataChangeCount>0){
							this.$message.error('还有待提交数据，请先提交')
						}
						else{
							this.$store.commit('setactiveindex','/orderManagement/addorder')
							this.$router.go(-1)
						}
					}
				}
				
				
				
			},
			init(){
				
				this.$api.getWmsTransOrderInfoByID(this.$route.query.id).then(res=>{
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					if(res.state=='success'){
						this.storelinks = res.data;
						this.dataList = res.data.children;
						this.orderInfo = res.data;
						this.warehouseChange(res.data.warehouseId)
						// console.log('更具ID详情---', this.storelinks)
						if(res.data.warehouseId){
							this.$api.getClientListByWarehouse({
								warehouseId: this.storelinks.warehouseId
							}).then(resss => {
								// res.data=JSON.parse(this.$decrypt(res.data)).data
								this.userList = resss.data
							})
						}else{
							this.$api.getClientListByWarehouse().then(reses => {
								// res.data=JSON.parse(this.$decrypt(res.data)).data
								this.userList = reses.data
							})
						}
						if(res.data.children.length==0 && res.data.status!=2){
							this.dataList.push({
								pdtCode: '',
								num: '',
								eaNum: '',
								warehouseLocationTo: ''
							})
						}
					}else{
						this.$message.error(res.message)
					}
				})
			},
			save(type) {
			    //   console.log(`调用保存按钮方法--${type}`);
			    },
			saveContent(e) {
			   var key = window.event.keyCode ? window.event.keyCode : window.event.which;
			   if (key === 83 && e.ctrlKey) {
			     this.save("hot key");
			     e.preventDefault(); //阻止浏览器默认事件
			   }
			},
			customerSelect(e){
                let obj = {};
				obj = this.userList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.customerId === e; //筛选出匹配数据
				});
				this.storelinks.customerId= e
                this.storelinks.customerName = obj.customerName
            },
			warehouseLis(e){
                this.$api.getWarehouseListByNowUser({
                    status: 1,
                    warehouseName: e
				}).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.entrepotList = res.data
					}
				})
			},
			warehouseChange(e){ //仓库选择
				// this.warehouseChangeNum++;
				//获取该仓库的全部库位
				this.$api.getLocationListNoParameter({
                    warehouseLocationName: '',
                    warehouseId: e,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
				// this.userList = [];
				// this.storelinks.customerId='';
                // this.storelinks.customerName = '';
				this.$api.getClientListByWarehouse({
					warehouseId: e
				}).then(res => {
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('客户数据--', res.data)
					this.userList = res.data
				})
			},
			districtFocus(e){ //库位查询
                this.$api.getLocationListNoParameter({
                    warehouseLocationName: e,
                    warehouseId: this.storelinks.warehouseId,
                    status: 1
                }).then((res) => {
					// console.log('2344--',res.data)
					if (res.state == 'success') {
						this.locationList = res.data
					}
				})
			},
		},
		beforeDestroy() {
		    //销毁时移除监听
		    document.removeEventListener("keydown", this.saveContent);
		},
		mounted() {
			document.addEventListener("focus", this.saveContent);
		},
		created() {
			if(this.$route.query.id){
				this.title='编辑'
				this.init()
			}else{
				this.title='新增'
				this.$api.addWmsTransOrderInfo().then(res => {
					// console.log('新增---', res.data)
					this.orderInfo = res.data;
					this.storelinks.status = 0;
					this.storelinks.orderCode = res.data.orderCode
				})
				// this.storelinks.storageTime = new Date();
				this.$api.getUserInfo().then((res) => {
					res.data = JSON.parse(this.$decrypt(res.data)).data
					// console.log('登录信息--',res);
					if (res.state == 'success') {
						this.storelinks.createBy = res.data.user.name
						// this.$api.getSerialNumberWmsTransOrder().then(res => { //序列号
						// 	if(res.state=='success'){
						// 		// console.log('4455--', res.message)
						// 		this.storelinks.orderCode = 'YKD'+res.message
						// 		// console.log('订单号---', 'YKD'+res.message)
						// 	}
						// })
					}
				})
				this.storelinks.storageTime = moment().format('YYYY-MM-DD')
				this.$api.getClientListByWarehouse().then(res => {
					// res.data=JSON.parse(this.$decrypt(res.data)).data
					// console.log('进来新增---', )
					this.userList = res.data
				})
			}
			// this.$api.fdriverList(this.$encrypt({})).then(res => {
			// 	res.data=JSON.parse(this.$decrypt(res.data)).data
			// 	this.driverList = res.data
			// })
			// this.$api.fcarsList(this.$encrypt({})).then(res => {
			// 	res.data=JSON.parse(this.$decrypt(res.data)).data
			// 	this.arsList = res.data
			// })
			
			// this.$api.findPmsUnit({}).then(res => {
				
			// 	this.unitList = res.data.list
			// })
			// this.$api.orderlist({
			// 	position: '运输单'
			// }).then(res => {
			
			// 	this.typeList = res.data
			// })
			
			
			// this.$api.findrouteList({}).then(res => {
			// 	this.routeList = res.data
			// })

			this.warehouseLis();
			// this.districtFocus();
		}
	}
</script>

<style>
	/* 新建的项目  去一下默认样式 */
	body,
	html {
		padding: 0;
		margin: 0;
	}
</style>
<style leng="less" scoped>
	.container {
		position: relative;
	}

	.detail {
		background: rgb(244, 249, 254);
		width: 880px;
		height: 60px;
		border-radius: 5px;
		padding: 10px;
		line-height: 30px;
		font-size: 14px;
		display: flex;
		justify-content: space-between;
	}

	.detaildt {
		/* width: 1380px; */
		width: 93%;
		margin: 50px;
		overflow: hidden;
		background: white;
		height: auto;
		border-radius: 10px;
	}
	/deep/.el-select-dropdown,.el-popper{
		width: 500px;
		padding: 0 20px;
	}
</style>